const middleware = {}

middleware['block-upload'] = require('../middleware/block-upload.js')
middleware['block-upload'] = middleware['block-upload'].default || middleware['block-upload']

middleware['error-redirect'] = require('../middleware/error-redirect.js')
middleware['error-redirect'] = middleware['error-redirect'].default || middleware['error-redirect']

middleware['pdf-proxy'] = require('../middleware/pdf-proxy.js')
middleware['pdf-proxy'] = middleware['pdf-proxy'].default || middleware['pdf-proxy']

export default middleware
